import { Skeleton, Text } from '@billda/design-system';
import { useStorageUsage } from '../../hooks/useStorageUsage';
import { formatFileSize } from './formatFileSize';

function getBarColorClass(percentage: number): string {
  if (percentage > 95) {
    return 'bg-surface-error';
  }
  if (percentage >= 80) {
    return 'bg-surface-warning';
  }
  return 'bg-surface-primary';
}

export function StorageBar() {
  const { data, isLoading } = useStorageUsage();

  if (isLoading) {
    return (
      <div className="px-4 py-2">
        <Skeleton variant="rectangular" height={6} className="rounded-lg" />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  const percentage =
    data.maxStorageSizeBytes > 0
      ? (data.currentStorageUsageBytes / data.maxStorageSizeBytes) * 100
      : 0;

  return (
    <div
      data-testid="storage-bar"
      className="flex items-center gap-3 px-4 py-2"
    >
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(Math.min(percentage, 100))}
        className="h-1.5 flex-1 overflow-hidden rounded-lg bg-surface-disabled"
      >
        <div
          className={`h-full rounded-lg transition-[width] ${getBarColorClass(percentage)}`}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      <Text variant="caption" color="secondary" className="whitespace-nowrap">
        {formatFileSize(data.currentStorageUsageBytes)} /{' '}
        {formatFileSize(data.maxStorageSizeBytes)} used
      </Text>
    </div>
  );
}
